export default __webpack_public_path__ + "static/media/Fastest area.0f5f29dc.gif";